import React from 'react'

export const HamburgerMenuIcon = ({ stroke = 'white' }) => (
  <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5625 23.6875H30.4375M1.5625 12.6875H30.4375M1.5625 1.6875H30.4375" stroke={stroke} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
